var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthchkupfoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22265",
    "data-name": "Group 22265",
    transform: "translate(-5511 237)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14529",
    "data-name": "Rectangle 14529",
    width: 30,
    height: 30,
    transform: "translate(5511 -237)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medical-equipment",
    d: "M19,8a2.993,2.993,0,0,0-1,5.816V15.5a4.5,4.5,0,0,1-9,0V14.48l3.124-2.5A4.976,4.976,0,0,0,14,8.078V3a1,1,0,0,0-1-1H11a1,1,0,0,0,0,2h1V8.078a2.986,2.986,0,0,1-1.125,2.342L8,12.72l-2.874-2.3A2.985,2.985,0,0,1,4,8.078V4H5A1,1,0,0,0,5,2H3A1,1,0,0,0,2,3V8.078a4.975,4.975,0,0,0,1.876,3.9L7,14.48V15.5a6.5,6.5,0,0,0,13,0V13.816A2.993,2.993,0,0,0,19,8Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,19,12Z",
    transform: "translate(5514 -234)",
    fill: "#333",
    stroke: "#f5f7f8",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthchkupfoot);
export default __webpack_public_path__ + "static/media/healthchkupfoot.2af607d0bf3c13163bed4b63d686b63b.svg";
export { ForwardRef as ReactComponent };